"use client";
import * as React from "react";
const SvgCoffeeSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12.89 0H0v7.11a6.2 6.2 0 0 0 6.22 6.22 6.2 6.2 0 0 0 6.23-6.22v-.89h.35A3.1 3.1 0 1 0 12.9 0m-2.22 1.78v2.66h-8.9V1.78zm2.22 2.66h-.44V1.78h.44a1.33 1.33 0 1 1 0 2.66M0 14.22h14.22V16H0z" }));
export {
  SvgCoffeeSharp as default
};
